(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireaf93"];
var parcelRegister = parcelRequire.register;
parcelRegister("lWUl7", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ffaab7a47e10b5b1$export$b3890eb0ae9dca99; });

var $ap0Jw = parcelRequire("ap0Jw");

var $aYz74 = parcelRequire("aYz74");

var $ckc4q = parcelRequire("ckc4q");
function $ffaab7a47e10b5b1$var$filterResults(results, filters) {
    return results.filter(function(hikeResult) {
        var matchedHike = true;
        // Handle if this is a Fuse result or not.
        var fields = (hikeResult.item ? hikeResult.item : hikeResult).fields;
        // Filter by details.
        var trail_details = fields.trail_details;
        var details = filters.details;
        var elevation = details.elevation, difficulty = details.difficulty, distance = details.distance;
        // Filter by elevation.
        if (elevation !== "all") {
            matchedHike = false;
            switch(elevation){
                case "500":
                    if (trail_details.trail_elevation) {
                        var trailElevation = parseInt(trail_details.trail_elevation.replace(",", ""));
                        if (trailElevation < 500) matchedHike = true;
                    }
                    break;
                case "1000":
                    if (trail_details.trail_elevation) {
                        var trailElevation1 = parseInt(trail_details.trail_elevation.replace(",", ""));
                        if (trailElevation1 < 1000 && trailElevation1 > 500) matchedHike = true;
                    }
                    break;
                case "2000":
                    if (trail_details.trail_elevation) {
                        var trailElevation2 = parseInt(trail_details.trail_elevation.replace(",", ""));
                        if (trailElevation2 < 2000 && trailElevation2 > 1000) matchedHike = true;
                    }
                    break;
                case "3000":
                    if (trail_details.trail_elevation) {
                        var trailElevation3 = parseInt(trail_details.trail_elevation.replace(",", ""));
                        if (trailElevation3 < 3000 && trailElevation3 > 2000) matchedHike = true;
                    }
                    break;
                case "3000+":
                    if (trail_details.trail_elevation) {
                        var trailElevation4 = parseInt(trail_details.trail_elevation.replace(",", ""));
                        if (trailElevation4 > 3000) matchedHike = true;
                    }
                    break;
            }
        }
        // Filter by distance.
        if (distance !== "all") {
            matchedHike = false;
            switch(distance){
                case "2":
                    if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 2) matchedHike = true;
                    break;
                case "5":
                    if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 5 && parseInt(trail_details.trail_distance) > 2) matchedHike = true;
                    break;
                case "8":
                    if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 8 && parseInt(trail_details.trail_distance) > 5) matchedHike = true;
                    break;
                case "10":
                    if (trail_details.trail_distance && parseInt(trail_details.trail_distance) < 10 && parseInt(trail_details.trail_distance) > 8) matchedHike = true;
                    break;
                case "10+":
                    if (trail_details.trail_distance && parseInt(trail_details.trail_distance) > 10) matchedHike = true;
                    break;
            }
        }
        // Filter by difficulty.
        if (difficulty !== "all" && difficulty !== trail_details.trail_difficulty) matchedHike = false;
        // Filter by features.
        var trail_features = fields.trail_features;
        var features = filters.features;
        var views = features.views, history = features.history, waterfall = features.waterfall, restroom = features.restroom, birds = features.birds, floods = features.floods, flowers = features.flowers, family = features.family, transit = features.transit;
        // Filter by views.
        if (views && !trail_features.beautiful_views) matchedHike = false;
        // Filter by history.
        if (history && !trail_features.cultural_history) matchedHike = false;
        // Filter by waterfall.
        if (waterfall && !trail_features.waterfalls) matchedHike = false;
        // Filter by restroom.
        if (restroom && !trail_features.restrooms) matchedHike = false;
        // Filter by birds.
        if (birds && !trail_features.bird_watching) matchedHike = false;
        // Filter by floods.
        if (floods && !trail_features.ice_age_floods) matchedHike = false;
        // Filter by flowers.
        if (flowers && !trail_features.wildflowers) matchedHike = false;
        // Filter by family.
        if (family && !trail_features.family_friendly) matchedHike = false;
        // Filter by public transit.
        if (transit && !trail_features.public_transit) matchedHike = false;
        // Return the result.
        return matchedHike;
    });
}
function $ffaab7a47e10b5b1$var$toggleSignupModal() {
    var signupModal = document.getElementById("fah-email-signup");
    // Hide/Show the modal element.
    signupModal.classList.toggle("block");
    signupModal.classList.toggle("hidden");
    // Unlock/Lock the html and body scroll.
    document.documentElement.classList.toggle("overflow-hidden");
    document.body.classList.toggle("overflow-hidden");
}
function $ffaab7a47e10b5b1$var$emailSignupGating() {
    return $ffaab7a47e10b5b1$var$_emailSignupGating.apply(this, arguments);
}
function $ffaab7a47e10b5b1$var$_emailSignupGating() {
    $ffaab7a47e10b5b1$var$_emailSignupGating = (0, $ap0Jw._)(function() {
        var hasSignedUp, searchQueryCount;
        return (0, $aYz74.__generator)(this, function(_state) {
            // Check if the has signed up for the email list local storage item exists.
            hasSignedUp = localStorage.getItem("frcg-email-signup");
            // If the user has signed up, return true to let search continue.
            if (hasSignedUp) return [
                2,
                true
            ];
            // Get the search query count from local storage.
            searchQueryCount = localStorage.getItem("frcg-search-query-count") || 0;
            // Iterate the search query count.
            localStorage.setItem("frcg-search-query-count", parseInt(searchQueryCount) + 1);
            // If the search query count is less than 3, return true to let search continue.
            if (searchQueryCount < 999999) return [
                2,
                true
            ];
            // Attach the signup form submit event.
            $ffaab7a47e10b5b1$var$attachSignupFormSubmitEvent();
            // Toggle the signup modal.
            $ffaab7a47e10b5b1$var$toggleSignupModal();
            // Return false to stop the search.
            return [
                2,
                false
            ];
        });
    });
    return $ffaab7a47e10b5b1$var$_emailSignupGating.apply(this, arguments);
}
function $ffaab7a47e10b5b1$var$attachSignupFormSubmitEvent() {
    // Listen for the form submit event.
    var signupForm = document.querySelector(".ngp-form form");
    signupForm.addEventListener("submit", function() {
        // Set the email signup local storage item.
        localStorage.setItem("frcg-email-signup", "true");
    });
}
function $ffaab7a47e10b5b1$export$b3890eb0ae9dca99() {
    // Get the form element and results.
    var fahSearch = document.getElementById("fah-search");
    var fahSearchResults = document.querySelectorAll(".find-a-hike__hike");
    // Get the hike data.
    var hikes = frcg.fah.hikes;
    // Set up the Fuse instance.
    var options = {
        keys: [
            "title",
            "description"
        ],
        useExtendedSearch: true,
        threshold: 0.3
    };
    var hikesSearch = new (0, $ckc4q.default)(hikes, options);
    // Add form submit listener to the form.
    fahSearch.addEventListener("submit", function() {
        var _ref = (0, $ap0Jw._)(function(e) {
            var canSearch, formData, trailQuery, results, filters, filteredResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hikeSearchResult, hikeSearchResultSlug, hikeSearchResultElement;
            return (0, $aYz74.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Prevent the default behavior and get form data.
                        e.preventDefault();
                        return [
                            4,
                            $ffaab7a47e10b5b1$var$emailSignupGating()
                        ];
                    case 1:
                        canSearch = _state.sent();
                        // If the user has not signed up, stop the search.
                        if (!canSearch) return [
                            2
                        ];
                        formData = new FormData(e.target);
                        // Run the search.
                        trailQuery = formData.get("trail-name");
                        results = trailQuery ? hikesSearch.search(trailQuery) : hikes;
                        // Filter the results.
                        filters = {
                            details: {
                                elevation: formData.get("filter-elevation"),
                                difficulty: formData.get("filter-difficulty"),
                                location: formData.get("filter-location"),
                                distance: formData.get("filter-distance")
                            },
                            features: {
                                views: formData.get("filter-views") ? true : false,
                                history: formData.get("filter-history") ? true : false,
                                waterfall: formData.get("filter-waterfall") ? true : false,
                                restroom: formData.get("filter-restroom") ? true : false,
                                birds: formData.get("filter-birds") ? true : false,
                                floods: formData.get("filter-floods") ? true : false,
                                flowers: formData.get("filter-flowers") ? true : false,
                                family: formData.get("filter-family") ? true : false,
                                transit: formData.get("filter-public-transit") ? true : false
                            }
                        };
                        filteredResults = $ffaab7a47e10b5b1$var$filterResults(results, filters);
                        // Hide all hikes.
                        fahSearchResults.forEach(function(hikeResult) {
                            hikeResult.classList.remove("find-a-hike__hike--active");
                        });
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // Show the results that match by IDs.
                            for(_iterator = filteredResults[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                hikeSearchResult = _step.value;
                                // Get the hike ID.
                                hikeSearchResultSlug = hikeSearchResult.item ? hikeSearchResult.item.slug : hikeSearchResult.slug;
                                // Show the hike element.
                                hikeSearchResultElement = document.getElementById("hike-".concat(hikeSearchResultSlug));
                                hikeSearchResultElement.classList.add("find-a-hike__hike--active");
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }());
    // Add form reset listener to the form.
    fahSearch.addEventListener("reset", function() {
        // Show all hikes.
        fahSearchResults.forEach(function(hikeResult) {
            hikeResult.classList.add("find-a-hike__hike--active");
        });
    });
}

});
parcelRegister("ckc4q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $645172dbb9e02194$export$2e2bcd8739ae039; });
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ 
var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $inKFz = parcelRequire("inKFz");

var $goUpr = parcelRequire("goUpr");

var $81JKW = parcelRequire("81JKW");

var $e6mbt = parcelRequire("e6mbt");

var $4KKVD = parcelRequire("4KKVD");
function $645172dbb9e02194$var$isArray(value) {
    return !Array.isArray ? $645172dbb9e02194$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
var $645172dbb9e02194$var$INFINITY = 1 / 0;
function $645172dbb9e02194$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    var result = value + "";
    return result == "0" && 1 / value == -$645172dbb9e02194$var$INFINITY ? "-0" : result;
}
function $645172dbb9e02194$var$toString(value) {
    return value == null ? "" : $645172dbb9e02194$var$baseToString(value);
}
function $645172dbb9e02194$var$isString(value) {
    return typeof value === "string";
}
function $645172dbb9e02194$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $645172dbb9e02194$var$isBoolean(value) {
    return value === true || value === false || $645172dbb9e02194$var$isObjectLike(value) && $645172dbb9e02194$var$getTag(value) == "[object Boolean]";
}
function $645172dbb9e02194$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $645172dbb9e02194$var$isObjectLike(value) {
    return $645172dbb9e02194$var$isObject(value) && value !== null;
}
function $645172dbb9e02194$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $645172dbb9e02194$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $645172dbb9e02194$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
var $645172dbb9e02194$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
var $645172dbb9e02194$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var $645172dbb9e02194$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function(key) {
    return "Invalid value for key ".concat(key);
};
var $645172dbb9e02194$var$PATTERN_LENGTH_TOO_LARGE = function(max) {
    return "Pattern length exceeds max of ".concat(max, ".");
};
var $645172dbb9e02194$var$MISSING_KEY_PROPERTY = function(name) {
    return "Missing ".concat(name, " property in key");
};
var $645172dbb9e02194$var$INVALID_KEY_WEIGHT_VALUE = function(key) {
    return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};
var $645172dbb9e02194$var$hasOwn = Object.prototype.hasOwnProperty;
var $645172dbb9e02194$var$KeyStore = /*#__PURE__*/ function() {
    "use strict";
    function KeyStore(keys) {
        var _this = this;
        (0, $6vyh9._)(this, KeyStore);
        this._keys = [];
        this._keyMap = {};
        var totalWeight = 0;
        keys.forEach(function(key) {
            var obj = $645172dbb9e02194$var$createKey(key);
            _this._keys.push(obj);
            _this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach(function(key) {
            key.weight /= totalWeight;
        });
    }
    (0, $l6JfT._)(KeyStore, [
        {
            key: "get",
            value: function get(keyId) {
                return this._keyMap[keyId];
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this._keys;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return JSON.stringify(this._keys);
            }
        }
    ]);
    return KeyStore;
}();
function $645172dbb9e02194$var$createKey(key) {
    var path = null;
    var id = null;
    var src = null;
    var weight = 1;
    var getFn = null;
    if ($645172dbb9e02194$var$isString(key) || $645172dbb9e02194$var$isArray(key)) {
        src = key;
        path = $645172dbb9e02194$var$createKeyPath(key);
        id = $645172dbb9e02194$var$createKeyId(key);
    } else {
        if (!$645172dbb9e02194$var$hasOwn.call(key, "name")) throw new Error($645172dbb9e02194$var$MISSING_KEY_PROPERTY("name"));
        var name = key.name;
        src = name;
        if ($645172dbb9e02194$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($645172dbb9e02194$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $645172dbb9e02194$var$createKeyPath(name);
        id = $645172dbb9e02194$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $645172dbb9e02194$var$createKeyPath(key) {
    return $645172dbb9e02194$var$isArray(key) ? key : key.split(".");
}
function $645172dbb9e02194$var$createKeyId(key) {
    return $645172dbb9e02194$var$isArray(key) ? key.join(".") : key;
}
function $645172dbb9e02194$var$get(obj, path) {
    var list = [];
    var arr = false;
    var deepGet = function(obj, path, index) {
        if (!$645172dbb9e02194$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            var key = path[index];
            var value = obj[key];
            if (!$645172dbb9e02194$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($645172dbb9e02194$var$isString(value) || $645172dbb9e02194$var$isNumber(value) || $645172dbb9e02194$var$isBoolean(value))) list.push($645172dbb9e02194$var$toString(value));
            else if ($645172dbb9e02194$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(var i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $645172dbb9e02194$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
var $645172dbb9e02194$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
var $645172dbb9e02194$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: function(a, b) {
        return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
    }
};
var $645172dbb9e02194$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
var $645172dbb9e02194$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $645172dbb9e02194$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $645172dbb9e02194$var$Config = (0, $81JKW._)({}, $645172dbb9e02194$var$BasicOptions, $645172dbb9e02194$var$MatchOptions, $645172dbb9e02194$var$FuzzyOptions, $645172dbb9e02194$var$AdvancedOptions);
var $645172dbb9e02194$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $645172dbb9e02194$var$norm() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, mantissa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var cache = new Map();
    var m = Math.pow(10, mantissa);
    return {
        get: function(value) {
            var numTokens = value.match($645172dbb9e02194$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            var norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            var n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear: function() {
            cache.clear();
        }
    };
}
var $645172dbb9e02194$var$FuseIndex = /*#__PURE__*/ function() {
    "use strict";
    function FuseIndex() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $645172dbb9e02194$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $645172dbb9e02194$var$Config.fieldNormWeight : _ref_fieldNormWeight;
        (0, $6vyh9._)(this, FuseIndex);
        this.norm = $645172dbb9e02194$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    (0, $l6JfT._)(FuseIndex, [
        {
            key: "setSources",
            value: function setSources() {
                var docs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.docs = docs;
            }
        },
        {
            key: "setIndexRecords",
            value: function setIndexRecords() {
                var records = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.records = records;
            }
        },
        {
            key: "setKeys",
            value: function setKeys() {
                var _this = this;
                var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                this.keys = keys;
                this._keysMap = {};
                keys.forEach(function(key, idx) {
                    _this._keysMap[key.id] = idx;
                });
            }
        },
        {
            key: "create",
            value: function create() {
                var _this = this;
                if (this.isCreated || !this.docs.length) return;
                this.isCreated = true;
                // List is Array<String>
                if ($645172dbb9e02194$var$isString(this.docs[0])) this.docs.forEach(function(doc, docIndex) {
                    _this._addString(doc, docIndex);
                });
                else // List is Array<Object>
                this.docs.forEach(function(doc, docIndex) {
                    _this._addObject(doc, docIndex);
                });
                this.norm.clear();
            }
        },
        {
            // Adds a doc to the end of the index
            key: "add",
            value: function add(doc) {
                var idx = this.size();
                if ($645172dbb9e02194$var$isString(doc)) this._addString(doc, idx);
                else this._addObject(doc, idx);
            }
        },
        {
            // Removes the doc at the specified index of the index
            key: "removeAt",
            value: function removeAt(idx) {
                this.records.splice(idx, 1);
                // Change ref index of every subsquent doc
                for(var i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
            }
        },
        {
            key: "getValueForItemAtKeyId",
            value: function getValueForItemAtKeyId(item, keyId) {
                return item[this._keysMap[keyId]];
            }
        },
        {
            key: "size",
            value: function size() {
                return this.records.length;
            }
        },
        {
            key: "_addString",
            value: function _addString(doc, docIndex) {
                if (!$645172dbb9e02194$var$isDefined(doc) || $645172dbb9e02194$var$isBlank(doc)) return;
                var record = {
                    v: doc,
                    i: docIndex,
                    n: this.norm.get(doc)
                };
                this.records.push(record);
            }
        },
        {
            key: "_addObject",
            value: function _addObject(doc, docIndex) {
                var _this = this;
                var record = {
                    i: docIndex,
                    $: {}
                };
                // Iterate over every key (i.e, path), and fetch the value at that key
                this.keys.forEach(function(key, keyIndex) {
                    var value = key.getFn ? key.getFn(doc) : _this.getFn(doc, key.path);
                    if (!$645172dbb9e02194$var$isDefined(value)) return;
                    if ($645172dbb9e02194$var$isArray(value)) {
                        var subRecords = [];
                        var stack = [
                            {
                                nestedArrIndex: -1,
                                value: value
                            }
                        ];
                        while(stack.length){
                            var _stack_pop = stack.pop(), nestedArrIndex = _stack_pop.nestedArrIndex, value1 = _stack_pop.value;
                            if (!$645172dbb9e02194$var$isDefined(value1)) continue;
                            if ($645172dbb9e02194$var$isString(value1) && !$645172dbb9e02194$var$isBlank(value1)) {
                                var subRecord = {
                                    v: value1,
                                    i: nestedArrIndex,
                                    n: _this.norm.get(value1)
                                };
                                subRecords.push(subRecord);
                            } else if ($645172dbb9e02194$var$isArray(value1)) value1.forEach(function(item, k) {
                                stack.push({
                                    nestedArrIndex: k,
                                    value: item
                                });
                            });
                        }
                        record.$[keyIndex] = subRecords;
                    } else if ($645172dbb9e02194$var$isString(value) && !$645172dbb9e02194$var$isBlank(value)) {
                        var subRecord1 = {
                            v: value,
                            n: _this.norm.get(value)
                        };
                        record.$[keyIndex] = subRecord1;
                    }
                });
                this.records.push(record);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    keys: this.keys,
                    records: this.records
                };
            }
        }
    ]);
    return FuseIndex;
}();
function $645172dbb9e02194$var$createIndex(keys, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $645172dbb9e02194$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $645172dbb9e02194$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var myIndex = new $645172dbb9e02194$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($645172dbb9e02194$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $645172dbb9e02194$var$parseIndex(data) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_getFn = _ref.getFn, getFn = _ref_getFn === void 0 ? $645172dbb9e02194$var$Config.getFn : _ref_getFn, _ref_fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref_fieldNormWeight === void 0 ? $645172dbb9e02194$var$Config.fieldNormWeight : _ref_fieldNormWeight;
    var keys = data.keys, records = data.records;
    var myIndex = new $645172dbb9e02194$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $645172dbb9e02194$var$computeScore$1(pattern) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_errors = _ref.errors, errors = _ref_errors === void 0 ? 0 : _ref_errors, _ref_currentLocation = _ref.currentLocation, currentLocation = _ref_currentLocation === void 0 ? 0 : _ref_currentLocation, _ref_expectedLocation = _ref.expectedLocation, expectedLocation = _ref_expectedLocation === void 0 ? 0 : _ref_expectedLocation, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $645172dbb9e02194$var$Config.distance : _ref_distance, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $645172dbb9e02194$var$Config.ignoreLocation : _ref_ignoreLocation;
    var accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    var proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $645172dbb9e02194$var$convertMaskToIndices() {
    var matchmask = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], minMatchCharLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $645172dbb9e02194$var$Config.minMatchCharLength;
    var indices = [];
    var start = -1;
    var end = -1;
    var i = 0;
    for(var len = matchmask.length; i < len; i += 1){
        var match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
var $645172dbb9e02194$var$MAX_BITS = 32;
function $645172dbb9e02194$var$search(text, pattern, patternAlphabet) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $645172dbb9e02194$var$Config.location : _ref_location, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $645172dbb9e02194$var$Config.distance : _ref_distance, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $645172dbb9e02194$var$Config.threshold : _ref_threshold, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $645172dbb9e02194$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $645172dbb9e02194$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $645172dbb9e02194$var$Config.includeMatches : _ref_includeMatches, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $645172dbb9e02194$var$Config.ignoreLocation : _ref_ignoreLocation;
    if (pattern.length > $645172dbb9e02194$var$MAX_BITS) throw new Error($645172dbb9e02194$var$PATTERN_LENGTH_TOO_LARGE($645172dbb9e02194$var$MAX_BITS));
    var patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    var textLen = text.length;
    // Handle the case when location > text.length
    var expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    var currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    var bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    var computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    var matchMask = computeMatches ? Array(textLen) : [];
    var index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        var score = $645172dbb9e02194$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            var i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    var lastBitArr = [];
    var finalScore = 1;
    var binMax = patternLen + textLen;
    var mask = 1 << patternLen - 1;
    for(var i1 = 0; i1 < patternLen; i1 += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        var binMin = 0;
        var binMid = binMax;
        while(binMin < binMid){
            var score1 = $645172dbb9e02194$var$computeScore$1(pattern, {
                errors: i1,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score1 <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        var start = Math.max(1, expectedLocation - binMid + 1);
        var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        var bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i1) - 1;
        for(var j = finish; j >= start; j -= 1){
            var currentLocation = j - 1;
            var charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i1) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $645172dbb9e02194$var$computeScore$1(pattern, {
                    errors: i1,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        var score2 = $645172dbb9e02194$var$computeScore$1(pattern, {
            errors: i1 + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score2 > currentThreshold) break;
        lastBitArr = bitArr;
    }
    var result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        var indices = $645172dbb9e02194$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $645172dbb9e02194$var$createPatternAlphabet(pattern) {
    var mask = {};
    for(var i = 0, len = pattern.length; i < len; i += 1){
        var char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
var $645172dbb9e02194$var$BitapSearch = /*#__PURE__*/ function() {
    "use strict";
    function BitapSearch(pattern) {
        var _this = this;
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $645172dbb9e02194$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $645172dbb9e02194$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $645172dbb9e02194$var$Config.distance : _ref_distance, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $645172dbb9e02194$var$Config.includeMatches : _ref_includeMatches, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $645172dbb9e02194$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $645172dbb9e02194$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $645172dbb9e02194$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $645172dbb9e02194$var$Config.ignoreLocation : _ref_ignoreLocation;
        (0, $6vyh9._)(this, BitapSearch);
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        var addChunk = function(pattern, startIndex) {
            _this.chunks.push({
                pattern: pattern,
                alphabet: $645172dbb9e02194$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        var len = this.pattern.length;
        if (len > $645172dbb9e02194$var$MAX_BITS) {
            var i = 0;
            var remainder = len % $645172dbb9e02194$var$MAX_BITS;
            var end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $645172dbb9e02194$var$MAX_BITS), i);
                i += $645172dbb9e02194$var$MAX_BITS;
            }
            if (remainder) {
                var startIndex = len - $645172dbb9e02194$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    (0, $l6JfT._)(BitapSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var _this_options = this.options, isCaseSensitive = _this_options.isCaseSensitive, includeMatches = _this_options.includeMatches;
                if (!isCaseSensitive) text = text.toLowerCase();
                // Exact match
                if (this.pattern === text) {
                    var result = {
                        isMatch: true,
                        score: 0
                    };
                    if (includeMatches) result.indices = [
                        [
                            0,
                            text.length - 1
                        ]
                    ];
                    return result;
                }
                // Otherwise, use Bitap algorithm
                var _this_options1 = this.options, location = _this_options1.location, distance = _this_options1.distance, threshold = _this_options1.threshold, findAllMatches = _this_options1.findAllMatches, minMatchCharLength = _this_options1.minMatchCharLength, ignoreLocation = _this_options1.ignoreLocation;
                var allIndices = [];
                var totalScore = 0;
                var hasMatches = false;
                this.chunks.forEach(function(param) {
                    var pattern = param.pattern, alphabet = param.alphabet, startIndex = param.startIndex;
                    var _search = $645172dbb9e02194$var$search(text, pattern, alphabet, {
                        location: location + startIndex,
                        distance: distance,
                        threshold: threshold,
                        findAllMatches: findAllMatches,
                        minMatchCharLength: minMatchCharLength,
                        includeMatches: includeMatches,
                        ignoreLocation: ignoreLocation
                    }), isMatch = _search.isMatch, score = _search.score, indices = _search.indices;
                    if (isMatch) hasMatches = true;
                    totalScore += score;
                    if (isMatch && indices) allIndices = (0, $e6mbt._)(allIndices).concat((0, $e6mbt._)(indices));
                });
                var result1 = {
                    isMatch: hasMatches,
                    score: hasMatches ? totalScore / this.chunks.length : 1
                };
                if (hasMatches && includeMatches) result1.indices = allIndices;
                return result1;
            }
        }
    ]);
    return BitapSearch;
}();
var $645172dbb9e02194$var$BaseMatch = /*#__PURE__*/ function() {
    "use strict";
    function BaseMatch(pattern) {
        (0, $6vyh9._)(this, BaseMatch);
        this.pattern = pattern;
    }
    (0, $l6JfT._)(BaseMatch, [
        {
            key: "search",
            value: function search() {}
        }
    ], [
        {
            key: "isMultiMatch",
            value: function isMultiMatch(pattern) {
                return $645172dbb9e02194$var$getMatch(pattern, this.multiRegex);
            }
        },
        {
            key: "isSingleMatch",
            value: function isSingleMatch(pattern) {
                return $645172dbb9e02194$var$getMatch(pattern, this.singleRegex);
            }
        }
    ]);
    return BaseMatch;
}();
function $645172dbb9e02194$var$getMatch(pattern, exp) {
    var matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
var $645172dbb9e02194$var$ExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(ExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(ExactMatch);
    function ExactMatch(pattern) {
        (0, $6vyh9._)(this, ExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(ExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text === this.pattern;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        this.pattern.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^="(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^=(.*)$/;
            }
        }
    ]);
    return ExactMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: !fire
var $645172dbb9e02194$var$InverseExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(InverseExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(InverseExactMatch);
    function InverseExactMatch(pattern) {
        (0, $6vyh9._)(this, InverseExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(InverseExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var index = text.indexOf(this.pattern);
                var isMatch = index === -1;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "inverse-exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!(.*)$/;
            }
        }
    ]);
    return InverseExactMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: ^file
var $645172dbb9e02194$var$PrefixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(PrefixExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(PrefixExactMatch);
    function PrefixExactMatch(pattern) {
        (0, $6vyh9._)(this, PrefixExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(PrefixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text.startsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        this.pattern.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "prefix-exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^\^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^\^(.*)$/;
            }
        }
    ]);
    return PrefixExactMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: !^fire
var $645172dbb9e02194$var$InversePrefixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(InversePrefixExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(InversePrefixExactMatch);
    function InversePrefixExactMatch(pattern) {
        (0, $6vyh9._)(this, InversePrefixExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(InversePrefixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = !text.startsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "inverse-prefix-exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!\^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!\^(.*)$/;
            }
        }
    ]);
    return InversePrefixExactMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: .file$
var $645172dbb9e02194$var$SuffixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(SuffixExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(SuffixExactMatch);
    function SuffixExactMatch(pattern) {
        (0, $6vyh9._)(this, SuffixExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(SuffixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = text.endsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        text.length - this.pattern.length,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "suffix-exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^"(.*)"\$$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^(.*)\$$/;
            }
        }
    ]);
    return SuffixExactMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: !.file$
var $645172dbb9e02194$var$InverseSuffixExactMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(InverseSuffixExactMatch, BaseMatch);
    var _super = (0, $4KKVD._)(InverseSuffixExactMatch);
    function InverseSuffixExactMatch(pattern) {
        (0, $6vyh9._)(this, InverseSuffixExactMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(InverseSuffixExactMatch, [
        {
            key: "search",
            value: function search(text) {
                var isMatch = !text.endsWith(this.pattern);
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: [
                        0,
                        text.length - 1
                    ]
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "inverse-suffix-exact";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^!"(.*)"\$$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^!(.*)\$$/;
            }
        }
    ]);
    return InverseSuffixExactMatch;
}($645172dbb9e02194$var$BaseMatch);
var $645172dbb9e02194$var$FuzzyMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(FuzzyMatch, BaseMatch);
    var _super = (0, $4KKVD._)(FuzzyMatch);
    function FuzzyMatch(pattern) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_location = _ref.location, location = _ref_location === void 0 ? $645172dbb9e02194$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $645172dbb9e02194$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $645172dbb9e02194$var$Config.distance : _ref_distance, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $645172dbb9e02194$var$Config.includeMatches : _ref_includeMatches, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $645172dbb9e02194$var$Config.findAllMatches : _ref_findAllMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $645172dbb9e02194$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $645172dbb9e02194$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $645172dbb9e02194$var$Config.ignoreLocation : _ref_ignoreLocation;
        (0, $6vyh9._)(this, FuzzyMatch);
        var _this;
        _this = _super.call(this, pattern);
        _this._bitapSearch = new $645172dbb9e02194$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
        return _this;
    }
    (0, $l6JfT._)(FuzzyMatch, [
        {
            key: "search",
            value: function search(text) {
                return this._bitapSearch.searchIn(text);
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "fuzzy";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^(.*)$/;
            }
        }
    ]);
    return FuzzyMatch;
}($645172dbb9e02194$var$BaseMatch);
// Token: 'file
var $645172dbb9e02194$var$IncludeMatch = /*#__PURE__*/ function(BaseMatch) {
    "use strict";
    (0, $goUpr._)(IncludeMatch, BaseMatch);
    var _super = (0, $4KKVD._)(IncludeMatch);
    function IncludeMatch(pattern) {
        (0, $6vyh9._)(this, IncludeMatch);
        return _super.call(this, pattern);
    }
    (0, $l6JfT._)(IncludeMatch, [
        {
            key: "search",
            value: function search(text) {
                var location = 0;
                var index;
                var indices = [];
                var patternLen = this.pattern.length;
                // Get all exact matches
                while((index = text.indexOf(this.pattern, location)) > -1){
                    location = index + patternLen;
                    indices.push([
                        index,
                        location - 1
                    ]);
                }
                var isMatch = !!indices.length;
                return {
                    isMatch: isMatch,
                    score: isMatch ? 0 : 1,
                    indices: indices
                };
            }
        }
    ], [
        {
            key: "type",
            get: function get() {
                return "include";
            }
        },
        {
            key: "multiRegex",
            get: function get() {
                return /^'"(.*)"$/;
            }
        },
        {
            key: "singleRegex",
            get: function get() {
                return /^'(.*)$/;
            }
        }
    ]);
    return IncludeMatch;
}($645172dbb9e02194$var$BaseMatch);
// ❗Order is important. DO NOT CHANGE.
var $645172dbb9e02194$var$searchers = [
    $645172dbb9e02194$var$ExactMatch,
    $645172dbb9e02194$var$IncludeMatch,
    $645172dbb9e02194$var$PrefixExactMatch,
    $645172dbb9e02194$var$InversePrefixExactMatch,
    $645172dbb9e02194$var$InverseSuffixExactMatch,
    $645172dbb9e02194$var$SuffixExactMatch,
    $645172dbb9e02194$var$InverseExactMatch,
    $645172dbb9e02194$var$FuzzyMatch
];
var $645172dbb9e02194$var$searchersLen = $645172dbb9e02194$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
var $645172dbb9e02194$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var $645172dbb9e02194$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $645172dbb9e02194$var$parseQuery(pattern) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return pattern.split($645172dbb9e02194$var$OR_TOKEN).map(function(item) {
        var query = item.trim().split($645172dbb9e02194$var$SPACE_RE).filter(function(item) {
            return item && !!item.trim();
        });
        var results = [];
        for(var i = 0, len = query.length; i < len; i += 1){
            var queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            var found = false;
            var idx = -1;
            while(!found && ++idx < $645172dbb9e02194$var$searchersLen){
                var searcher = $645172dbb9e02194$var$searchers[idx];
                var token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $645172dbb9e02194$var$searchersLen){
                var searcher1 = $645172dbb9e02194$var$searchers[idx];
                var token1 = searcher1.isSingleMatch(queryItem);
                if (token1) {
                    results.push(new searcher1(token1, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
var $645172dbb9e02194$var$MultiMatchSet = new Set([
    $645172dbb9e02194$var$FuzzyMatch.type,
    $645172dbb9e02194$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ var $645172dbb9e02194$var$ExtendedSearch = /*#__PURE__*/ function() {
    "use strict";
    function ExtendedSearch(pattern) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref_isCaseSensitive === void 0 ? $645172dbb9e02194$var$Config.isCaseSensitive : _ref_isCaseSensitive, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $645172dbb9e02194$var$Config.includeMatches : _ref_includeMatches, _ref_minMatchCharLength = _ref.minMatchCharLength, minMatchCharLength = _ref_minMatchCharLength === void 0 ? $645172dbb9e02194$var$Config.minMatchCharLength : _ref_minMatchCharLength, _ref_ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref_ignoreLocation === void 0 ? $645172dbb9e02194$var$Config.ignoreLocation : _ref_ignoreLocation, _ref_findAllMatches = _ref.findAllMatches, findAllMatches = _ref_findAllMatches === void 0 ? $645172dbb9e02194$var$Config.findAllMatches : _ref_findAllMatches, _ref_location = _ref.location, location = _ref_location === void 0 ? $645172dbb9e02194$var$Config.location : _ref_location, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? $645172dbb9e02194$var$Config.threshold : _ref_threshold, _ref_distance = _ref.distance, distance = _ref_distance === void 0 ? $645172dbb9e02194$var$Config.distance : _ref_distance;
        (0, $6vyh9._)(this, ExtendedSearch);
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $645172dbb9e02194$var$parseQuery(this.pattern, this.options);
    }
    (0, $l6JfT._)(ExtendedSearch, [
        {
            key: "searchIn",
            value: function searchIn(text) {
                var query = this.query;
                if (!query) return {
                    isMatch: false,
                    score: 1
                };
                var _this_options = this.options, includeMatches = _this_options.includeMatches, isCaseSensitive = _this_options.isCaseSensitive;
                text = isCaseSensitive ? text : text.toLowerCase();
                var numMatches = 0;
                var allIndices = [];
                var totalScore = 0;
                // ORs
                for(var i = 0, qLen = query.length; i < qLen; i += 1){
                    var searchers = query[i];
                    // Reset indices
                    allIndices.length = 0;
                    numMatches = 0;
                    // ANDs
                    for(var j = 0, pLen = searchers.length; j < pLen; j += 1){
                        var searcher = searchers[j];
                        var _searcher_search = searcher.search(text), isMatch = _searcher_search.isMatch, indices = _searcher_search.indices, score = _searcher_search.score;
                        if (isMatch) {
                            numMatches += 1;
                            totalScore += score;
                            if (includeMatches) {
                                var type = searcher.constructor.type;
                                if ($645172dbb9e02194$var$MultiMatchSet.has(type)) allIndices = (0, $e6mbt._)(allIndices).concat((0, $e6mbt._)(indices));
                                else allIndices.push(indices);
                            }
                        } else {
                            totalScore = 0;
                            numMatches = 0;
                            allIndices.length = 0;
                            break;
                        }
                    }
                    // OR condition, so if TRUE, return
                    if (numMatches) {
                        var result = {
                            isMatch: true,
                            score: totalScore / numMatches
                        };
                        if (includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                // Nothing was matched
                return {
                    isMatch: false,
                    score: 1
                };
            }
        }
    ], [
        {
            key: "condition",
            value: function condition(_, options) {
                return options.useExtendedSearch;
            }
        }
    ]);
    return ExtendedSearch;
}();
var $645172dbb9e02194$var$registeredSearchers = [];
function $645172dbb9e02194$var$register() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _registeredSearchers;
    (_registeredSearchers = $645172dbb9e02194$var$registeredSearchers).push.apply(_registeredSearchers, (0, $e6mbt._)(args));
}
function $645172dbb9e02194$var$createSearcher(pattern, options) {
    for(var i = 0, len = $645172dbb9e02194$var$registeredSearchers.length; i < len; i += 1){
        var searcherClass = $645172dbb9e02194$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $645172dbb9e02194$var$BitapSearch(pattern, options);
}
var $645172dbb9e02194$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
var $645172dbb9e02194$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
var $645172dbb9e02194$var$isExpression = function(query) {
    return !!(query[$645172dbb9e02194$var$LogicalOperator.AND] || query[$645172dbb9e02194$var$LogicalOperator.OR]);
};
var $645172dbb9e02194$var$isPath = function(query) {
    return !!query[$645172dbb9e02194$var$KeyType.PATH];
};
var $645172dbb9e02194$var$isLeaf = function(query) {
    return !$645172dbb9e02194$var$isArray(query) && $645172dbb9e02194$var$isObject(query) && !$645172dbb9e02194$var$isExpression(query);
};
var $645172dbb9e02194$var$convertToExplicit = function(query) {
    return (0, $inKFz._)({}, $645172dbb9e02194$var$LogicalOperator.AND, Object.keys(query).map(function(key) {
        return (0, $inKFz._)({}, key, query[key]);
    }));
};
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $645172dbb9e02194$var$parse(query, options) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_auto = _ref.auto, auto = _ref_auto === void 0 ? true : _ref_auto;
    var next = function(query) {
        var keys = Object.keys(query);
        var isQueryPath = $645172dbb9e02194$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$645172dbb9e02194$var$isExpression(query)) return next($645172dbb9e02194$var$convertToExplicit(query));
        if ($645172dbb9e02194$var$isLeaf(query)) {
            var key = isQueryPath ? query[$645172dbb9e02194$var$KeyType.PATH] : keys[0];
            var pattern = isQueryPath ? query[$645172dbb9e02194$var$KeyType.PATTERN] : query[key];
            if (!$645172dbb9e02194$var$isString(pattern)) throw new Error($645172dbb9e02194$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            var obj = {
                keyId: $645172dbb9e02194$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $645172dbb9e02194$var$createSearcher(pattern, options);
            return obj;
        }
        var node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach(function(key) {
            var value = query[key];
            if ($645172dbb9e02194$var$isArray(value)) value.forEach(function(item) {
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$645172dbb9e02194$var$isExpression(query)) query = $645172dbb9e02194$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $645172dbb9e02194$var$computeScore(results, param) {
    var _param_ignoreFieldNorm = param.ignoreFieldNorm, ignoreFieldNorm = _param_ignoreFieldNorm === void 0 ? $645172dbb9e02194$var$Config.ignoreFieldNorm : _param_ignoreFieldNorm;
    results.forEach(function(result) {
        var totalScore = 1;
        result.matches.forEach(function(param) {
            var key = param.key, norm = param.norm, score = param.score;
            var weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $645172dbb9e02194$var$transformMatches(result, data) {
    var matches = result.matches;
    data.matches = [];
    if (!$645172dbb9e02194$var$isDefined(matches)) return;
    matches.forEach(function(match) {
        if (!$645172dbb9e02194$var$isDefined(match.indices) || !match.indices.length) return;
        var indices = match.indices, value = match.value;
        var obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $645172dbb9e02194$var$transformScore(result, data) {
    data.score = result.score;
}
function $645172dbb9e02194$var$format(results, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_includeMatches = _ref.includeMatches, includeMatches = _ref_includeMatches === void 0 ? $645172dbb9e02194$var$Config.includeMatches : _ref_includeMatches, _ref_includeScore = _ref.includeScore, includeScore = _ref_includeScore === void 0 ? $645172dbb9e02194$var$Config.includeScore : _ref_includeScore;
    var transformers = [];
    if (includeMatches) transformers.push($645172dbb9e02194$var$transformMatches);
    if (includeScore) transformers.push($645172dbb9e02194$var$transformScore);
    return results.map(function(result) {
        var idx = result.idx;
        var data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach(function(transformer) {
            transformer(result, data);
        });
        return data;
    });
}
var $645172dbb9e02194$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Fuse(docs) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, index = arguments.length > 2 ? arguments[2] : void 0;
        (0, $6vyh9._)(this, Fuse);
        this.options = (0, $81JKW._)({}, $645172dbb9e02194$var$Config, options);
        this.options.useExtendedSearch;
        this._keyStore = new $645172dbb9e02194$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    (0, $l6JfT._)(Fuse, [
        {
            key: "setCollection",
            value: function setCollection(docs, index) {
                this._docs = docs;
                if (index && !(index instanceof $645172dbb9e02194$var$FuseIndex)) throw new Error($645172dbb9e02194$var$INCORRECT_INDEX_TYPE);
                this._myIndex = index || $645172dbb9e02194$var$createIndex(this.options.keys, this._docs, {
                    getFn: this.options.getFn,
                    fieldNormWeight: this.options.fieldNormWeight
                });
            }
        },
        {
            key: "add",
            value: function add(doc) {
                if (!$645172dbb9e02194$var$isDefined(doc)) return;
                this._docs.push(doc);
                this._myIndex.add(doc);
            }
        },
        {
            key: "remove",
            value: function remove() {
                var predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
                    return false;
                };
                var results = [];
                for(var i = 0, len = this._docs.length; i < len; i += 1){
                    var doc = this._docs[i];
                    if (predicate(doc, i)) {
                        this.removeAt(i);
                        i -= 1;
                        len -= 1;
                        results.push(doc);
                    }
                }
                return results;
            }
        },
        {
            key: "removeAt",
            value: function removeAt(idx) {
                this._docs.splice(idx, 1);
                this._myIndex.removeAt(idx);
            }
        },
        {
            key: "getIndex",
            value: function getIndex() {
                return this._myIndex;
            }
        },
        {
            key: "search",
            value: function search(query) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_limit = _ref.limit, limit = _ref_limit === void 0 ? -1 : _ref_limit;
                var _this_options = this.options, includeMatches = _this_options.includeMatches, includeScore = _this_options.includeScore, shouldSort = _this_options.shouldSort, sortFn = _this_options.sortFn, ignoreFieldNorm = _this_options.ignoreFieldNorm;
                var results = $645172dbb9e02194$var$isString(query) ? $645172dbb9e02194$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                $645172dbb9e02194$var$computeScore(results, {
                    ignoreFieldNorm: ignoreFieldNorm
                });
                if (shouldSort) results.sort(sortFn);
                if ($645172dbb9e02194$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
                return $645172dbb9e02194$var$format(results, this._docs, {
                    includeMatches: includeMatches,
                    includeScore: includeScore
                });
            }
        },
        {
            key: "_searchStringList",
            value: function _searchStringList(query) {
                var searcher = $645172dbb9e02194$var$createSearcher(query, this.options);
                var records = this._myIndex.records;
                var results = [];
                // Iterate over every string in the index
                records.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$645172dbb9e02194$var$isDefined(text)) return;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) results.push({
                        item: text,
                        idx: idx,
                        matches: [
                            {
                                score: score,
                                value: text,
                                norm: norm,
                                indices: indices
                            }
                        ]
                    });
                });
                return results;
            }
        },
        {
            key: "_searchLogical",
            value: function _searchLogical(query) {
                var _this = this;
                var expression = $645172dbb9e02194$var$parse(query, this.options);
                var evaluate = function(node, item, idx) {
                    if (!node.children) {
                        var keyId = node.keyId, searcher = node.searcher;
                        var matches = _this._findMatches({
                            key: _this._keyStore.get(keyId),
                            value: _this._myIndex.getValueForItemAtKeyId(item, keyId),
                            searcher: searcher
                        });
                        if (matches && matches.length) return [
                            {
                                idx: idx,
                                item: item,
                                matches: matches
                            }
                        ];
                        return [];
                    }
                    var res = [];
                    for(var i = 0, len = node.children.length; i < len; i += 1){
                        var _res;
                        var child = node.children[i];
                        var result = evaluate(child, item, idx);
                        if (result.length) (_res = res).push.apply(_res, (0, $e6mbt._)(result));
                        else if (node.operator === $645172dbb9e02194$var$LogicalOperator.AND) return [];
                    }
                    return res;
                };
                var records = this._myIndex.records;
                var resultMap = {};
                var results = [];
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if ($645172dbb9e02194$var$isDefined(item)) {
                        var expResults = evaluate(expression, item, idx);
                        if (expResults.length) {
                            // Dedupe when adding
                            if (!resultMap[idx]) {
                                resultMap[idx] = {
                                    idx: idx,
                                    item: item,
                                    matches: []
                                };
                                results.push(resultMap[idx]);
                            }
                            expResults.forEach(function(param) {
                                var matches = param.matches;
                                var _resultMap_idx_matches;
                                (_resultMap_idx_matches = resultMap[idx].matches).push.apply(_resultMap_idx_matches, (0, $e6mbt._)(matches));
                            });
                        }
                    }
                });
                return results;
            }
        },
        {
            key: "_searchObjectList",
            value: function _searchObjectList(query) {
                var _this = this;
                var searcher = $645172dbb9e02194$var$createSearcher(query, this.options);
                var _this__myIndex = this._myIndex, keys = _this__myIndex.keys, records = _this__myIndex.records;
                var results = [];
                // List is Array<Object>
                records.forEach(function(param) {
                    var item = param.$, idx = param.i;
                    if (!$645172dbb9e02194$var$isDefined(item)) return;
                    var matches = [];
                    // Iterate over every key (i.e, path), and fetch the value at that key
                    keys.forEach(function(key, keyIndex) {
                        var _matches;
                        (_matches = matches).push.apply(_matches, (0, $e6mbt._)(_this._findMatches({
                            key: key,
                            value: item[keyIndex],
                            searcher: searcher
                        })));
                    });
                    if (matches.length) results.push({
                        idx: idx,
                        item: item,
                        matches: matches
                    });
                });
                return results;
            }
        },
        {
            key: "_findMatches",
            value: function _findMatches(param) {
                var key = param.key, value = param.value, searcher = param.searcher;
                if (!$645172dbb9e02194$var$isDefined(value)) return [];
                var matches = [];
                if ($645172dbb9e02194$var$isArray(value)) value.forEach(function(param) {
                    var text = param.v, idx = param.i, norm = param.n;
                    if (!$645172dbb9e02194$var$isDefined(text)) return;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) matches.push({
                        score: score,
                        key: key,
                        value: text,
                        idx: idx,
                        norm: norm,
                        indices: indices
                    });
                });
                else {
                    var text = value.v, norm = value.n;
                    var _searcher_searchIn = searcher.searchIn(text), isMatch = _searcher_searchIn.isMatch, score = _searcher_searchIn.score, indices = _searcher_searchIn.indices;
                    if (isMatch) matches.push({
                        score: score,
                        key: key,
                        value: text,
                        norm: norm,
                        indices: indices
                    });
                }
                return matches;
            }
        }
    ]);
    return Fuse;
}();
$645172dbb9e02194$export$2e2bcd8739ae039.version = "7.0.0";
$645172dbb9e02194$export$2e2bcd8739ae039.createIndex = $645172dbb9e02194$var$createIndex;
$645172dbb9e02194$export$2e2bcd8739ae039.parseIndex = $645172dbb9e02194$var$parseIndex;
$645172dbb9e02194$export$2e2bcd8739ae039.config = $645172dbb9e02194$var$Config;
$645172dbb9e02194$export$2e2bcd8739ae039.parseQuery = $645172dbb9e02194$var$parse;
$645172dbb9e02194$var$register($645172dbb9e02194$var$ExtendedSearch);

});
parcelRegister("6vyh9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4bd039c07ff87b2c$export$71511d61b312f219; });
function $4bd039c07ff87b2c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("l6JfT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f5dd4342c917a997$export$71511d61b312f219; });
function $f5dd4342c917a997$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f5dd4342c917a997$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $f5dd4342c917a997$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f5dd4342c917a997$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("inKFz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d61e93935e56369c$export$71511d61b312f219; });
function $d61e93935e56369c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("goUpr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf0aa4f9100b744d$export$71511d61b312f219; });

var $jvBnt = parcelRequire("jvBnt");
function $bf0aa4f9100b744d$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $jvBnt._)(subClass, superClass);
}

});
parcelRegister("jvBnt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e33de80036d82669$export$71511d61b312f219; });
function $e33de80036d82669$export$71511d61b312f219(o, p) {
    $e33de80036d82669$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e33de80036d82669$export$71511d61b312f219(o, p);
}

});


parcelRegister("81JKW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5d81e8f62e10ca47$export$71511d61b312f219; });

var $inKFz = parcelRequire("inKFz");
function $5d81e8f62e10ca47$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $inKFz._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("e6mbt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a442d583aa7dd23e$export$71511d61b312f219; });

var $avvz3 = parcelRequire("avvz3");

var $WHfHR = parcelRequire("WHfHR");

var $jsaCH = parcelRequire("jsaCH");

var $lhr0B = parcelRequire("lhr0B");
function $a442d583aa7dd23e$export$71511d61b312f219(arr) {
    return (0, $avvz3._)(arr) || (0, $WHfHR._)(arr) || (0, $lhr0B._)(arr) || (0, $jsaCH._)();
}

});
parcelRegister("avvz3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a6548ae98c4734a$export$71511d61b312f219; });

var $4gXCX = parcelRequire("4gXCX");
function $7a6548ae98c4734a$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $4gXCX._)(arr);
}

});
parcelRegister("4gXCX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $31c6e8c60fad3330$export$71511d61b312f219; });
function $31c6e8c60fad3330$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("WHfHR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b06f7e7f640b300$export$71511d61b312f219; });
function $0b06f7e7f640b300$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jsaCH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e298df5d1943e412$export$71511d61b312f219; });
function $e298df5d1943e412$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lhr0B", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7e022dc72c51eb9$export$71511d61b312f219; });

var $4gXCX = parcelRequire("4gXCX");
function $f7e022dc72c51eb9$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $4gXCX._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $4gXCX._)(o, minLen);
}

});


parcelRegister("4KKVD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $375fdc5cdd65aace$export$71511d61b312f219; });

var $j5BSo = parcelRequire("j5BSo");

var $6kNb6 = parcelRequire("6kNb6");

var $h38BI = parcelRequire("h38BI");
function $375fdc5cdd65aace$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $6kNb6._)();
    return function _createSuperInternal() {
        var Super = (0, $j5BSo._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $j5BSo._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $h38BI._)(this, result);
    };
}

});
parcelRegister("j5BSo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de5bdd6bec912574$export$71511d61b312f219; });
function $de5bdd6bec912574$export$71511d61b312f219(o) {
    $de5bdd6bec912574$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $de5bdd6bec912574$export$71511d61b312f219(o);
}

});

parcelRegister("6kNb6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $49cac21318f65b09$export$71511d61b312f219; });
function $49cac21318f65b09$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($49cac21318f65b09$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("h38BI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c69964bc2b833cb0$export$71511d61b312f219; });

var $jXapY = parcelRequire("jXapY");

var $cQSqJ = parcelRequire("cQSqJ");
function $c69964bc2b833cb0$export$71511d61b312f219(self, call) {
    if (call && ((0, $cQSqJ._)(call) === "object" || typeof call === "function")) return call;
    return (0, $jXapY._)(self);
}

});
parcelRegister("jXapY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e86b9bca3b843a3e$export$71511d61b312f219; });
function $e86b9bca3b843a3e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});





})();
//# sourceMappingURL=find-a-hike-search.89d45c9f.js.map
